import { cloneElement, useId, type ReactElement } from "react";

type FormControlProps = {
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
  "aria-labelledby"?: string;
  "aria-required"?: boolean;
};

type AdminEditorFormRowProps = {
  label: string;
  required?: boolean;
  error?: string;
  className?: string;
  children: ReactElement<FormControlProps>;
};

/** 后台编辑表单行：对齐房资源左标签右控件布局。 */
export function AdminEditorFormRow({
  label,
  required = false,
  error,
  className,
  children,
}: AdminEditorFormRowProps) {
  const id = useId();
  const labelId = `${id}-label`;
  const errorId = `${id}-error`;
  return (
    <div className={["admin-editor-form-row", className].filter(Boolean).join(" ")}>
      <div id={labelId} className="admin-editor-form-row__label">
        {required ? <span aria-hidden="true">*</span> : null}
        {label}
      </div>
      <div className="admin-editor-form-row__control">
        {cloneElement(children, {
          "aria-labelledby": labelId,
          "aria-required": required || undefined,
          "aria-invalid": Boolean(error) || undefined,
          "aria-describedby": error ? errorId : undefined,
        })}
        {error ? (
          <div id={errorId} role="alert" className="admin-editor-form-error">
            {error}
          </div>
        ) : null}
      </div>
    </div>
  );
}
